import React, { useCallback } from "react";
import ReactDOM from "react-dom"
import { canUseDOM } from '../../../../utils/ssr';
import ArticleSearchContainer from '../../../containers/ArticleSearchContainer';
import FormItemsContainer from '../../../containers/FormItemsContainer';
import SearchModal from "./SearchModal";
import { ModalWindow, Modal } from "../../../../components/Modal";
import ResearchBtn from "./ResearchBtn";

const DetailSearchForm = () => {
  const { areaIds, aggs, setAreaIds, search, searchDeps  } = ArticleSearchContainer.useContainer();
  const { items } = FormItemsContainer.useContainer();

  if (!canUseDOM()){
    return null;
  }

  const stateAndDispatch = {
    ids: areaIds,
    aggs: aggs.area_count.area,
    setIds: setAreaIds,
  };

  const onSearch = useCallback(() => {
    search();
  }, [...searchDeps]);


  return ReactDOM.createPortal(
    <ModalWindow>
      {(open, close, isActive) => (
      <>
        <ResearchBtn open={open}></ResearchBtn>
        <Modal
          isActive={isActive}
          closeModal={close}
        >
          <SearchModal
          searchDeps={searchDeps}
          closeModal={close}
          search={onSearch}
          items={items}
          {...stateAndDispatch}
          />
        </Modal>
      </>
      )}
      </ModalWindow>
    ,
    document.getElementById('jsReSearchBtn')
  )
};

export default DetailSearchForm;